import { render } from "./Forbrug.vue?vue&type=template&id=f2fdd476&scoped=true"
import script from "./Forbrug.vue?vue&type=script&lang=js"
export * from "./Forbrug.vue?vue&type=script&lang=js"

import "./Forbrug.vue?vue&type=style&index=0&id=f2fdd476&scoped=true&lang=css"

import exportComponent from "C:\\MartinRud-CloudRoot\\Firma\\Code\\PHP\\byensegenbil.dk\\byensegenbil.dk-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f2fdd476"]])

export default __exports__